import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const CopyContext = createContext({ t: (_k, fb = "") => fb, loaded: false, refresh: async () => {} });

export function CopyProvider({ children }) {
  const [copy, setCopy] = useState({});
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/site-copy");
      setCopy(data || {});
    } catch {
      // network error — fall back to defaults already in JSX
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const t = useCallback(
    (key, fallback = "") => (copy[key] !== undefined && copy[key] !== null ? copy[key] : fallback),
    [copy]
  );

  // Don't render the app until the real copy has arrived — otherwise every
  // page briefly shows hardcoded fallback text (whatever's written in the
  // JSX) before swapping to the real values a moment later. That swap is
  // the "old content, then new content" flash on every page load.
  if (!loaded) {
    return <div className="min-h-screen bg-[#121212]" />;
  }

  return <CopyContext.Provider value={{ t, loaded, refresh }}>{children}</CopyContext.Provider>;
}

export const useCopy = () => useContext(CopyContext);
